import NotificationActions from '../../actions/NotificationActions';
import UserStore from '../../stores/UserStore';
import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndpoints } from '../../constants/GuestListConstants';
import { endPoints as UserEndpoints } from '../../constants/UserConstants';
import { RegisterLedgerEntryTypes } from '../../constants/RegisterLedgerConstants';
import PageRow from '../form/layout/PageRow.react';
import Input from '../form/input/Input.react';
import Price from '../form/Price.react';
import ConfirmPopup from '../common/ConfirmPopup.react';

class GLTransactionsAdjustment extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            cashOpening : 0,
            cashEnding : 0,
            cashExpected : 0,
            newBalance: 0,
            cashCounted  : 0,
            deposit      : 0,
            startingBalance : 0,
            differenceReason : '',

            managerPin : '',
        };

        this.setCashOpening = this.setCashOpening.bind(this);
        this.checkManagerPin = this.checkManagerPin.bind(this);
        this.isValid = this.isValid.bind(this);
        this.update = this.update.bind(this);
        this.formatNewBalance = this.formatNewBalance.bind(this);
    }

    componentDidMount() {
        this.setCashOpening(this.props);
    }

    componentWillReceiveProps(next) {
        this.setCashOpening(next);
    }

    checkManagerPin() {
        var self = this;

        AjaxPromises.POST(UserEndpoints.CHECK_PIN_NUMBER, UserStore.getApiData({
            PinCode : this.state.managerPin
        })).then(res => {
            if (res.Data[0].MgrPermission === true) {
                self.update();
            } else {
                NotificationActions.error('Incorrect Manager PIN');
            }
        })
    }

    setCashOpening(dataObj) {
        var cashOpening = dataObj.startingBalance;
        var alreadyClosed = false;
        var cashEnding  = dataObj.endingBalance;
        var cashExpected = dataObj.transactionTotal;
        var newBalance = dataObj.newBalance;
        
        var startingBalance = parseFloat(cashOpening).toFixed(2); 
        if(isNaN(startingBalance)) {
            startingBalance = 0;
        }
        if (isNaN(newBalance) || newBalance == '') {
            newBalance = 0;
        }
        this.setState({
            cashOpening,
            cashEnding,
            cashExpected,
            startingBalance,
            alreadyClosed,
            newBalance
        });
    }

    isValid() {
        var location = UserStore.getState().selectedLocation;

        if (location.MgrPinForDeposit && this.state.managerPin.length === 0)
            return false;

        return (
            parseFloat(this.state.cashCounted) > 0 &&
            parseFloat(this.state.startingBalance) != null &&
            parseFloat(this.state.newBalance) >= 0 &&
            parseFloat(this.state.cashCounted) > parseFloat(this.state.newBalance) &&
            !this.state.alreadyClosed
        );
    }

    formatNewBalance() {
        this.props.setNewBalance(parseFloat(this.state.newBalance).toFixed(2));
    }

    update() {
        var self = this;

        if (!this.isValid() || this.state.loading) {
            return;
        }

        var cashOpening = this.state.cashOpening;
        var cashEnding  = this.state.cashEnding;
        var cashExpected = this.state.cashExpected;

        var formData = UserStore.getApiData();
        formData.RegisterId = this.props.selectedRegister.id;
        formData.CashOpening = cashOpening;
        formData.CashEnding = cashEnding;
        formData.CashExpected = cashExpected;
        formData.CashCounted = this.state.cashCounted;
        formData.Difference = this.state.cashCounted - cashEnding;
        formData.Deposit = parseFloat(this.state.cashCounted - this.state.newBalance).toFixed(2);
        formData.SetRegisterBalance = this.state.newBalance;
        formData.DifferenceReason = this.state.differenceReason;
        formData.EntryTypeId = RegisterLedgerEntryTypes.CloseoutPOS;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(GuestListEndpoints.REGISTER_CLOSE_OUT,
                formData
            ).then(res => {
                self.setState({ loading : false }, () => {
                    if (res.Data[0] && res.Data[0].ResultId === 1) {
                        self.setState({ cashCounted : 0, differenceReason : '', newBalance : 0, managerPin : '' }, () => {
                            NotificationActions.success('Register Closed out');
                            self.setCashOpening(self.props);
                            self.props.onReload();
                        })
                    } else
                        NotificationActions.error('Something went wrong');
                })
            });
        });
    }

    render() {
        var location = UserStore.getState().selectedLocation;
        var cashOpening = this.state.cashOpening;
        var cashEnding  = this.state.cashEnding;
        var cashExpected = this.state.cashExpected;
        var doBlindCloseOut = location.UseBlindRegisterCloseOut;

        return ([
            !doBlindCloseOut && [<PageRow title={<Price price={cashOpening} dollar />}>
                <div className='transactions__label'>
                    Starting Balance
                </div>
            </PageRow>,

            <PageRow title={<Price price={cashExpected} dollar />}>
                <div className='transactions__label'>
                    Cash Income
                </div>
            </PageRow>,

            <PageRow title={<Price price={cashEnding} dollar />}>
                <div className='transactions__label'>
                    Ending Balance
                </div>
            </PageRow>
            ],
            <PageRow title={
                <Input
                    value={this.state.cashCounted}
                    onChange={cashCounted => { this.setState({ cashCounted }); }} />
                }>
                <div className='transactions__label'>
                    Cash Counted
                </div>
            </PageRow>,

            !doBlindCloseOut && 
            <PageRow title={<Price price={this.state.cashCounted - cashEnding} dollar />}>
                <div className='transactions__label'>
                    Difference
                </div>
            </PageRow>,

            <PageRow title={
                <Input
                    value={this.state.newBalance}
                    onChange={newBalance => { this.props.setNewBalance(newBalance) }}
                    onBlur={this.formatNewBalance} />
                }>
                <div className='transactions__label'>
                    New Balance
                </div>
            </PageRow>,

            <PageRow title={<Price price={(parseFloat(this.state.cashCounted) - parseFloat(this.state.newBalance)).toFixed(2)} dollar />}>
                    <div className='transactions__label'>
                        Deposit
                    </div>
            </PageRow>,

            <PageRow title={
                <Input
                    value={this.state.differenceReason}
                    onChange={differenceReason => { this.setState({ differenceReason }); }} />
                }>
                <div className='transactions__label'>
                    Note
                </div>
            </PageRow>,

            ( location.MgrPinForDeposit &&
                <PageRow title={
                    <Input
                        type='password'
                        id='mgr-pass-for-close-out'
                        value={this.state.managerPin}
                        onChange={managerPin => { this.setState({ managerPin }); }} />
                    }>
                    <div className='transactions__label'>
                        Manager PIN
                    </div>
                </PageRow>
            ),

            <PageRow>
                <ConfirmPopup
                    buttonLabel='Close Out'
                    onConfirm={() => { location.MgrPinForDeposit ? this.checkManagerPin() : this.update() }}
                    type='button'
                    disabled={!this.isValid()} />
            </PageRow>,
        ]);
    }
}

export default GLTransactionsAdjustment;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLTransactionsCloseOut.react.jsx